import LiteYoutubePreview from '@/DesignSystem/features/YoutubePreview';
import { Box, Modal } from '@mui/material';

const YoutubeModalComponent = ({ youtubeUrl, open, onClose }) => {
    if (!youtubeUrl) {
        return null;
    }

    // Función para extraer el videoId de una URL de YouTube
    const getVideoId = (url) => {
        try {
            const urlObj = new URL(url);
            let videoId;

            // Verificar si la URL es de youtu.be o youtube.com
            if (urlObj.hostname.includes('youtu.be')) {
                videoId = urlObj.pathname.slice(1); // Extraer el ID del video
            } else if (urlObj.hostname.includes('youtube.com')) {
                // Intentar obtener desde el parámetro 'v' (videos normales)
                videoId = urlObj.searchParams.get('v');

                // Si no hay parámetro 'v', buscar en el pathname (para /live/ o /embed/)
                if (!videoId) {
                    const pathMatch = urlObj.pathname.match(/\/(live|embed|v)\/([a-zA-Z0-9_-]+)/);
                    if (pathMatch && pathMatch[2]) {
                        videoId = pathMatch[2];
                    }
                }
            }

            return videoId;
        } catch (error) {
            console.error('Error al procesar la URL del video:', error);
            return null;
        }
    };

    const videoId = getVideoId(youtubeUrl);
    if (!videoId) return null;

    const screenWidth = window.innerWidth;
    let modalWidth = screenWidth * 0.9;

    if (screenWidth > 450 && screenWidth < 600) {
        modalWidth = 450;
    } else if (screenWidth > 600 && screenWidth < 800) {
        modalWidth = 600;
    } else if (screenWidth > 800 && screenWidth < 1000) {
        modalWidth = 800;
    } else if (screenWidth > 1000 && screenWidth < 1200) {
        modalWidth = 1000;
    } else if (screenWidth > 1200) {
        modalWidth = 800;
    }

    const modalHeight = modalWidth * 0.5625;

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            >
                <LiteYoutubePreview
                    videoId={videoId}
                    width={modalWidth}
                    height={modalHeight}
                    isModal={true}
                />
            </Box>
        </Modal>
    );
};

export default YoutubeModalComponent;
